import {Component, Inject, input, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {Exam} from '@app/api/models/exam';

import {DATE_FORMAT, TIME_FORMAT} from '@app/api/constants';
import {DatePipe} from '@angular/common';
import {WaBadgeDirective, WaCardDirective, WaIconDirective} from "angular-awesome";

@Component({
  selector: 'app-survey-correction-list-element',
  templateUrl: './correction-list-element.component.html',
  styleUrls: ['./correction-list-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DatePipe, WaCardDirective, WaIconDirective, WaBadgeDirective]
})
export class CorrectionListElementComponent implements OnInit {

  readonly exam = input.required<Exam>();
  readonly selected = input<boolean>(false);
  readonly showControls = input<boolean>(false);

  tooltipText: string = '';
  statusIcon: string = '';
  locationNames = new Set<string>();

  constructor(@Inject(DATE_FORMAT) public dateFormat: string, @Inject(TIME_FORMAT) public timeFormat: string) {
  }

  ngOnInit(): void {
    if (!this.exam()) {
      return;
    } else {
      this.exam()!.rooms.forEach(room => {
        this.locationNames.add(room.location.name);
      });
    }
  }
}
